import React from 'react'
import ReactDOM from 'react-dom'
import {
  Button,
  Dropdown,
  Icon,
  Image,
  Loader,
  Menu,
  Popup,
} from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { bindActionCreators } from 'redux'

import { Anchor } from 'components/Anchor'
import { mydOauthLogoutURL, mydOauthURL, MYD_ENV } from 'config'
import MydNotifications from 'react-components/myd-notifications'
import { MydUserMenu } from 'react-components/myd-user-menu'
import { fetchNotifications } from '_actions/notifications'
import { fetchUserMenu } from '_actions/auth'
import store from 'store'
import { changeDataNav } from '_actions/nav'
import _t from 'utils/i18n_helper'
import { pusher } from 'config'

import './nav.css'


class _NavLogged extends React.Component {
  constructor(props) {
    super(props)

    this.node = React.createRef()

    this.state = {
      isLoading: false,
      notificationsPage: 1,
      menu:{
        open: false,
      },
      mainMenu: [],
      profileMenu: {
        isFetching: true,
        data: [],
      },
      isLoadingMenu: false,
      sidebarOpen: false,
      sidebarLevel: 0,
      mainMenuOpen: false,
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.handleMobileMenu = this.handleMobileMenu.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  onScroll(e, a,b) {
    const element = e.target
    if (
      ! this.props.notifications.isFetching &&
      element.scrollHeight - element.scrollTop === element.clientHeight
    ) {
      let newPage = this.state.notificationsPage + 1
      this.setState({
        notificationsPage: newPage,
      })
      this.props.fetchNotifications(newPage, 10, true)
    }
    return false
  }

  componentDidMount() {
    let { auth } = this.props

    this.subscribeToUserChannel(auth.user.id)

    document.addEventListener('mousedown', this.handleClick, false)

    this.props.fetchNotifications(this.state.notificationsPage).catch(err => {
      console.log(err)
    })

    fetchUserMenu('profile').then(
      menu => {
        this.setState({
          profileMenu: {
            isFetching: false,
            data: menu,
          }
        })
      }
    ).catch(err => console.log('Error Loading user menu'))

    if (auth.user.isAdmin && !auth.user.isIndividual)
      return

    fetchUserMenu('main').then(
      menu => {
        this.setState({
          isLoadingMenu: false,
          mainMenu: menu,
        })

        this.buildMainMenu()
      }
    ).catch(err => console.log('Error Loading user menu'))

  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  handleClick(e) {
    const node = ReactDOM.findDOMNode(this.node.current)
    if (this.props.nav.open === true && ! node.contains(e.target)) {
      this.toggleMenu()
    }
  }

  toggleMenu() {
    let { nav } = this.props

    store.dispatch(changeDataNav({
      open: ! nav.open,
    }))
  }

  subscribeToUserChannel(userId) {
    let channelName = 'notifications-' + userId
    let channel = pusher.subscribe(channelName)
    channel.bind('new-notification', _.bind(this.onNewNotification, this))
  }

  loadNewNotification() {
    this.props.fetchNotifications().catch(err => console.log(err))
  }

  onNewNotification() {
    this.loadNewNotification()
  }

  buildMainMenu() {
    let { mainMenu } = this.state
    let menuParent = _.filter(mainMenu, {parentId: null})
    let menuChilds = _.filter(mainMenu, m => { return m.parentId != null })
    menuParent = _.orderBy(menuParent, ['order'], ['asc'])
    menuChilds = _.orderBy(menuChilds, ['order'], ['asc'])

    let allMenu = _.map(menuParent, m => {
      return {
      ...m,
       childs: _.filter(menuChilds, {parentId: m.id}),
      }
    })

    this.setState({
      mainMenu: allMenu,
    })
  }

  onSetSidebarOpen(open) {
    this.setState({sidebarOpen: open})

    if (open === false){
      this.setState(
        {
          sidebarLevel: 0
        }
      )
    }
  }

  handleMobileMenu(item){
    this.setState({
      sidebarLevel: item
    })
  }

  render() {
    const {
      history,
      languages,
      auth,
      notifications,
      match,
      nav,
      nav: {
        icon,
        title,
        secondaryLogo,
      },
      i18n,
    } = this.props

    const {
      isLoadingMenu,
      mainMenu,
      profileMenu,
    } = this.state

    let userMenuOptions = false
    let userMenu = <Menu.Item><Loader active inline size='small' /></Menu.Item>
    let countNotifications
    let languageOptions = _.map(languages.languages, lang => ({
      ...lang,
      active: lang.value === languages.selected,
    }))
    let profileMenuOrdered = _.orderBy(profileMenu.data, ['order'], ['asc'])
    let _secondaryLogo = secondaryLogo

    if (
      _.isNull(_secondaryLogo) &&
      auth.user.ecosystem.logo
    ) {
      _secondaryLogo = {
        src: auth.user.ecosystem.logo,
        alt: auth.user.ecosystem.name,
      }
    }

    if (auth.isLogged) {
      userMenuOptions = [
        {
          key: 'eportfolio',
          image: (
            <span
              className='myd_avatar small'
              style={{
                'backgroundImage': `url('${auth.user.avatar.tiny}')`}
              }
            />
          ),
          text: `${auth.user.firstName} ${auth.user.lastName}`,
          value: 'eportfolio',
          active: match.path === '/eportfolio/:username',
          onClick: () => history.push('/eportfolio/mine'),
        },
        // {key: 2, icon: 'share', text: 'Share eportfolio', value: 'share_eportfolio'},
      ]

      userMenuOptions = [
        ...userMenuOptions,
        ..._.map(profileMenuOrdered, i => {
          const link = i.url.search('http') !== -1

          return {
            key: `profile_${i.id}`,
            icon: i.icon,
            image: i.image !== null ? <Icon><span className='myd_avatar tiny' style={{ 'backgroundImage': `url('${i.image}')` }} /></Icon> : null,
            text: _t(i.labelKey, true),
            value: `profile_${i.id}`,
            onClick: () => ( ! link && history.push(i.url) ),
            as: link ? 'a' : Dropdown.Item,
            href: link ? i.url : null,
            target: i.target,
            active: i.url === match.url,
          }
        }),
        {
          key: 'btn_logout',
          icon: 'sign out',
          text: _t('USER_MENU_LOGOUT', true),
          value: 'logout',
          onClick: () => {
            localStorage.removeItem('mydToken')
            window.location = mydOauthLogoutURL()
          }
        },
      ]

      userMenu = (
        <>
          <Menu.Item className='myd-topbar-avatar'>
            <span
              className='myd_avatar small'
              style={{'backgroundImage': `url('${auth.user.avatar.tiny}')`,'cursor':'pointer'}}
              onClick= { () => history.push('/eportfolio/mine') }
            />
          </Menu.Item>
          <Dropdown
            item
            icon='chevron down'
            className='myd-topbar-dropdown'
            options={ userMenuOptions }
            text=' '
          />
        </>
      )

      countNotifications = (
        <span>
          {
            notifications.isFetching === false ?
            notifications.meta.countUnread :
            <Loader active inline size='tiny'/>
          }
          <Popup
            on='click'
            className='myd-notifications-popup'
            trigger={ <Icon link color='red' name='bell' /> }
            position='bottom right'
            onScroll={this.onScroll}
            hideOnScroll={false}
            content= {
              <MydNotifications
                loading={ notifications.isFetching }
                notifications={ notifications.data }
              />
            }
            flowing
          />
        </span>
      )
    }

    let buttonType = nav.open ? 'close' : 'bars'

    return (
      <Menu fixed='top' className='myd-topbar' ref={ this.node }>
        {
          MYD_ENV !== 'production' &&
          <span style={{
            backgroundColor: 'red',
            padding: '5px 10px',
            color: 'white',
            fontWeight: 'bold',
            position: 'fixed',
            top: '58px',
            right: '0',
            borderRadius: '0 0 0 10px',
          }}>{MYD_ENV}</span>
        }
        <Menu.Item icon className='myd-open-menu'>
          <Loader size='tiny' active={ isLoadingMenu } />
          <Icon name={ buttonType } size='big' link onClick={ this.toggleMenu } style={{'minWidth': '54px'}}/>
        </Menu.Item>
        {
          nav.open &&
          <MydUserMenu
            menu={ mainMenu }
            isLoadingMenu= { isLoadingMenu }
           { ...this.props}
          />
        }
        <Menu.Item className='myd-topbar-icon'>
          <a rel='noopener noreferrer' href='http://www.mydocumenta.com' target='_blank'>
            <Image src='https://s3-eu-west-1.amazonaws.com/myd-resources/icons/icon_mydocumenta.png' alt='Mydocumenta Logo' />
          </a>
        </Menu.Item>
        <Menu.Item className='myd-topbar-icon'>
          <a rel='noopener noreferrer' href={auth.user.ecosystem.url} target='_blank'>
            <Image { ..._secondaryLogo } />
          </a>
        </Menu.Item>
        <Menu.Item className='myd-topbar-title'>
          {
            icon.search('http') !== -1 ?
            <Image size='mini' className='myd_avatar' src={ icon } /> :
            <Icon name={ icon } color='red' size='large' />
          }
          { title }
        </Menu.Item>
        <Menu.Menu position='right'>
          <Dropdown
            floating
            loading={ i18n.isFetching === true }
            item
            value={ i18n.lang }
            onChange={ (e, {value}) => this.props.changeLanguage(value) }
            options={ languageOptions }
          />
          <Menu.Item>
            { countNotifications }
          </Menu.Item>
          { userMenu }
        </Menu.Menu>
      </Menu>
    )
  }
}

export const NavLogged = withRouter(connect(
  (store) => ({
    auth: store.auth,
    notifications: store.notifications,
    languages: store.languages,
    nav: store.nav,
    i18n: store.i18n,
  }),
  (dispatch) => ({
    fetchNotifications: bindActionCreators(fetchNotifications, dispatch),
  })
)(_NavLogged))


class _GuestNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      menu:{
        open: false,
      },
      profileMenu: {
        isFetching: true,
        data: [],
      },
      isLoadingMenu: false,
      sidebarOpen: false,
      sidebarLevel: 0,
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.handleMobileMenu = this.handleMobileMenu.bind(this)
  }

  onSetSidebarOpen(open) {
    this.setState({sidebarOpen: open})

    if (open === false){
      this.setState(
        {
          sidebarLevel: 0
        }
      )
    }
  }

  handleMobileMenu(item){
    this.setState({
      sidebarLevel: item
    })
  }

  render() {
    const {
      languages,
      nav,
      i18n,
    } = this.props
    const {
      icon,
      title,
    } = nav
    let userMenuOptions = false
    let userMenu = <Menu.Item><Loader active inline size='small' /></Menu.Item>
    let languageOptions = _.map(languages.languages, lang => ({
      ...lang,
      active: lang.value === languages.selected,
    }))

    userMenuOptions = [
      {
        key: 'btn_login',
        icon: 'sign in',
        text: 'Login',
        value: 'login',
        onClick: () => {
          window.location = mydOauthURL()
        }
      },
    ]

    userMenu = (
      <>
        <Anchor href={mydOauthURL()} style={{'z-index': '1' }}>
          <Button
            color='grey'
            className='myd-login-button'
          >Login</Button>
        </Anchor>
        <Dropdown
          item
          icon='chevron down'
          className='myd-topbar-dropdown'
          options={ userMenuOptions }
          text=' '
        />
      </>
    )

    return (
      <Menu fixed='top' className='myd-topbar'>
        {
          MYD_ENV !== 'production' &&
          <span style={{
            backgroundColor: 'red',
            padding: '5px 10px',
            color: 'white',
            fontWeight: 'bold',
            position: 'fixed',
            top: '58px',
            right: '0',
            borderRadius: '0 0 0 10px',
          }}>{MYD_ENV}</span>
        }
        <Menu.Item className='myd-topbar-icon'>
          <a rel='noopener noreferrer' href='http://www.mydocumenta.com' target='_blank'>
            <Image src='https://s3-eu-west-1.amazonaws.com/myd-resources/icons/icon_mydocumenta.png' alt='Mydocumenta Logo' />
          </a>
        </Menu.Item>
        <Menu.Item className='myd-topbar-title'>
          {
            icon.search('http') !== -1 ?
            <Image size='mini' className='myd_avatar' src={ icon } /> :
            <Icon name={ icon } color='red' size='large' />
          }
          { title }
        </Menu.Item>
        <Menu.Menu position='right'>
          <Dropdown
            floating
            loading={ i18n.isFetching === true }
            item
            value={ i18n.lang }
            onChange={ (e, {value}) => this.props.changeLanguage(value) }
            options={ languageOptions }
          />
          { userMenu }
        </Menu.Menu>
      </Menu>
    )
  }
}

export const GuestNav = connect(
  store => ({
    languages: store.languages,
    nav: store.nav,
    i18n: store.i18n,
  })
)(_GuestNav)


const Nav = props => {
  if (props.auth.isLogged) {
     return <NavLogged changeLanguage={ props.changeLanguage } />

  } else {
     return <GuestNav changeLanguage={ props.changeLanguage } />

  }
}

export default connect(
  store => ({
    auth: store.auth,
  })
)(Nav)
